/**
 * Created On : 8th Feb 2018
 * Usage  : Displays HighCharts On Multiple Cards Dynamically by incrementing the id which creates different div tag to hold the different charts on the page
 * Coprights : Johnson Controls India Pvt Ltd.
 **/

import { Component, Input, Output, EventEmitter} from "@angular/core";
import * as HighCharts from "highcharts";
import { HomeService } from "../../../pages/home/home.service";
import { PointService } from "../../../services/point.service";
import { OAuthService } from 'angular-oauth2-oidc';
import {AlertController} from "ionic-angular";
import { SecurityConfiguration } from '../../../security/security.configuration';


declare let self: any;

@Component({
    
    selector: 'trends-charts-card',
    providers:[HomeService],
    styles: [` 
        ion-card-header {
            background: #4478b4;
            font-size: 1.2rem;
            color: white;
            padding: 8px;
        }   
        .container {
            height: 28vh;
        }
        .bold-fonts {
            font-weight: bolder;
        }          
        ion-card {
            margin-left: 0 !important;
            width: 100% !important;
            box-shadow: 1px 1px 30px 0px #bcbcbc !important;
            height: 35vh;
        }
        .no-data {
            margin-top: 10vh;
            font-size: 2rem;
            color: #4478b4;
        }
        .doc-icon {
            color: aliceblue;
            margin-top: -25px;
            margin-bottom: -13px;
            padding:0px
        }
    `],
    template: `
            <ion-card>
                <ion-card-header class="bold-fonts">
                    <span float-left text-overflow-ellipsis width-75vw>{{pointName}} ({{fromunit}})</span>
                    <div float-right>
                        <button ion-button clear small (tap)="seriesData?.length > 0 && showGridData(id, pointName,PointsDatatype)" class="doc-icon">
                           <img src="../assets/imgs/doc.jpg"/>  
                        </button> 
                        <button ion-button clear small [attr.id]="'zoom_' + id" class="doc-icon">
                        <img *ngIf="!isZoomed" src="../assets/imgs/Zoom.jpg"/>
                        <img *ngIf="isZoomed" src="../assets/imgs/zoomout.jpg"/> 
                        </button>                               
                    </div>
                </ion-card-header>
                <ion-card-content padding>
                    <div *ngIf="seriesData?.length != 0" class="container" [attr.id]="'container_' + id"></div>
                    <div *ngIf="seriesData?.length == 0" class="container no-data" [attr.id]="'container_' + id" text-center>{{'Nodataavailable' | translate}}</div>
                </ion-card-content>
            </ion-card> 
     `
})

export class TrendsChartCard {
    @Output() chartClick = new EventEmitter();
    @Input() id: string;
    @Input() type: string;
    @Input() seriesData: any;
    @Input() LineData:any;
    @Input() attributeName: any;
    @Input() pointName: any;
    @Input() PointsDatatype: any;
    @Input() charttype:any;
    @Input() ColumnChartData: any;
    @Input() fromunit: string;
    @Output() pointClick = new EventEmitter();
    @Output() showGrid = new EventEmitter();
    @Output() enableZoom = new EventEmitter();
    @Input() isZoomed: boolean;
    public emitData: EmitModel;
    public dataTime: any = "";
    public dataValue: any = "";
    public showGetData: boolean = false;
    public isData:boolean=false;

    private chartPointClick = function (x, y, event) {
        this.pointClick.emit([x, y, event]);
        this.pointService.setPointClicked(x, y);
    }

    constructor(
        private pointService:PointService,
        private _oAuthService: OAuthService,
        private alertCtrl:AlertController,
        private securityConfig:SecurityConfiguration
    ) {
        self = this;
    }

    ngAfterViewInit() {
    //     setTimeout(()=>{    //<<<---    using ()=> syntax
    //         this.messageSuccess = false;
    //    }, 3000);
        if (this.seriesData && this.seriesData.length > 0) {
            if (this.type == "bar") {
                var isCodedValue = false;
                if (this.PointsDatatype == "Coded Value")
                    isCodedValue = true;
                this.showBarchart(this.ColumnChartData, this.pointName, this, this.id,isCodedValue);
            }
            else {
                this.showdynamicChart(this.isZoomed, this.id, this.seriesData, this.type, this.pointName,this.LineData, this);
            }
        }
    }

    showdynamicChart(isZoomed, id, seriesData, type, attributeName,LineData, that) {

        var chartSeriesList = [];
        var i: number;
            if (this.seriesData.length > 0) {
                let objchartSeries = new chartSeries();

                objchartSeries.name = LineData.pointname;
                /*  if (i == 0)
                     objchartSeries.color = '#7cb5ec';
                 else
                     objchartSeries.color = '#000000'; */
                objchartSeries.color = '#7cb5ec';
                objchartSeries.data = LineData.LineChartData;
                objchartSeries.connectNulls = false;
                objchartSeries.dataLabels = true;
                objchartSeries.showInLegend = false;
                objchartSeries.turboThreshold = 30000;
                objchartSeries.pointPadding = 0.6;
                objchartSeries.groupPadding = 0.3;
                objchartSeries.borderWidth = 0;
                objchartSeries.shadow = false;
                objchartSeries.marker = {
                    enabled: false
                }
                chartSeriesList.push(objchartSeries);

            
        }
        var self = this;
        let chart = HighCharts.chart("container_" + this.id, {
            chart: {
                type: this.type,
                // height: (9 / 19 * 100) + '%' 
                reflow: true,
                zoomType: 'x'
            },
            global: {
                useUTC: false
            },
            credits: {
                enabled: false
            },
            options: {
                chart: {
                    //type: 'area',
                    //width:200,
                    // height: 187,
                    reflow: true,
                    backgroundColor: null, zoomType: 'x'
                },
                plotOptions: {
                    series: {
                        cursor: 'pointer',
                        point: {
                            events: {
                                // click: function (e) {
                                //     ////HighSlide code
                                //     $('.highslide-footer').remove();
                                //     var date = new Date(new Date(this.x).getTime() + (new Date(this.x).getTimezoneOffset() * 60000));
                                //     var dateTime = $filter('date')(date, "MM-dd-yyyy HH:mm:ss");
                                //     var UnitStatus = 'UnitStatus';
                                //     var htmlString = '<table style="width: 100%; font-size: 10px;"><tr><td style="text-align:center;"> <button id="btnCall" onclick="$(\'#funcDiv\').attr(\'y\',\'' + this.y
                                //         + '\');$(\'#funcDiv\').attr(\'x\',\'' + this.x + '\');$(\'#funcDiv\').attr(\'z\',\'' + this.series.name + '\');$(\'#funcDiv\').attr(\'u\',\'' + UnitStatus + '\');hs.close(this);$(\'#funcDiv\').click();"  style="color:#fff;background:#00c4b5;padding:5px; border:1px solid #00b5a7;border-radius:2px;" >Get Data</button></td></tr> </table>     '

                                //     var yAxisValue = this.y - 1;

                                //     hs.htmlExpand(null, {
                                //         pageOrigin: {
                                //             x: e.pageX + 60 || e.clientX + 60,
                                //             y: e.pageY + 60 || e.clientY + 60
                                //         },
                                //         headingText: '<span style=font-size:10px;>' + dateTime + ' ' + '-' + ' ' + '<b>(' + yAxisValue + ')</b></span>',
                                //         maincontentText: htmlString,
                                //         width: 200
                                //     });
                                //     hs.Expander.prototype.onBeforeClose = function (sender) {
                                //     }
                                // }
                            }
                        }
                    }
                }
            },
            title: {
                text: ''
            },
            xAxis: {
                showFirstLabel: true,
                // tickInterval: '172800000',
                // tickInterval: tickInterval,
                dateTimeLabelFormats: {
                    Hour: '%m/%d/%Y %H:%M '
                },
                type: 'datetime'
            },
            tooltip: {
                useHTML: true,
                headerFormat: '',
                pointFormatter: function () {
                    var toolTipDate = new Date(new Date(this.x).getTime() + (new Date(this.x).getTimezoneOffset() * 60000));
                    var tooltiptext = '<span>' + HighCharts.dateFormat('%m/%d/' + self.seriesTooltipYear(toolTipDate, this.series.name.split('-')[0]) + ' %H:%M:%S ', this.x) + '</span>';
                    tooltiptext = tooltiptext + '<br><span style="color:' + this.series.color + '">' + this.series.name + '</span><b>: ' + HighCharts.numberFormat(this.y, 2) + ' </b></br>';

                    return tooltiptext;
                }

            },
            yAxis: {
                gridLineWidth: 1,
                lineWidth: 1,
                title: {
                    text: null
                }
            },
            dataLabels: {
                enabled: true,
                crop: false,
                overflow: 'none'
            },
            plotOptions: {

                series: {
                    cursor: 'pointer',
                    point: {
                        events: {
                            // click: function (e) {
                            //     //self.pointClickedTimeStamp=e.timeStamp;
                            //     //self.chartClicked();
                            //     var toolTipDate = new Date(new Date(this.x).getTime() + (new Date(this.x).getTimezoneOffset() * 60000));
                            //     var val = HighCharts.numberFormat(this.y, 2);
                            //     var x = toolTipDate.toLocaleDateString();
                            //     var t = new Date(x);
                            //     var curr_date = t.getDate();
                            //     var curr_month = t.getMonth() + 1; //Months are zero based
                            //     var curr_year = t.getFullYear();
                            //     var x1 = curr_year + "-" + curr_month + "-" + curr_date;
                            //     var y = toolTipDate.toLocaleTimeString('en-US', { hour12: false });
                            //     var dateVal = x1 + " " + y;
                            //     dateVal = self.pad((toolTipDate.getMonth() + 1)) + "-" + self.pad(toolTipDate.getDate()) + "-" + self.pad(toolTipDate.getFullYear()) + " " + self.pad(toolTipDate.getHours()) + ":" + self.pad(toolTipDate.getMinutes()) + ":" + self.pad(toolTipDate.getSeconds());
                            //     self.chartClicked(dateVal, val, e.pageX - 240, e.pageY - 385);
                                
                                    click: function ($event) {
                                        self.chartPointClick(new Date(this.x).getTime() + (new Date(this.x).getTimezoneOffset() * 60000), this.y, $event);
                                    
                            }

                        }
                    }
                },

                spline: {
                    marker: {
                        enabled: false
                    }
                },
            },
            series: chartSeriesList
        }

        )};

    private pad(val) {
        val < 10 ? val = "0" + val : val;
        return val;
    }

    showBarchart(chartData, chartName, that, id,isCodedValue) {
        var self = this;
        let chart = HighCharts.chart("container_" + id, {
            // this.pointchartConfig = {
            chart: {
                type: 'column',
                height: (9 / 19 * 100) + '%',
                zoomType: 'x'
            },
            global: {
                useUTC: false
            },
            credits: {
                enabled: false
            },
            options: {
                chart: {
                    type: 'column',
                    height: 187,
                    backgroundColor: null, zoomType: 'x'
                },
                // plotOptions: {
                //     series: {
                //         cursor: 'pointer',
                //         point: {
                //             // events: {
                //             //     click: function (e) {
                //             //         ////HighSlide code
                //             //         $('.highslide-footer').remove();
                //             //         var date = new Date(new Date(this.x).getTime() + (new Date(this.x).getTimezoneOffset() * 60000));
                //             //         var dateTime = $filter('date')(date, "MM-dd-yyyy HH:mm:ss");

                //             //         var htmlString = '<table style="width: 100%; font-size: 10px;"><tr><td style="text-align:center;"> <button id="btnCall" onclick="$(\'#funcDiv\').attr(\'y\',\'' + this.y
                //             //             + '\');$(\'#funcDiv\').attr(\'x\',\'' + this.x + '\');$(\'#funcDiv\').attr(\'z\',\'' + undefined + '\');hs.close(this);$(\'#funcDiv\').click();"  style="color:#fff;background:#00c4b5;padding:5px; border:1px solid #00b5a7;border-radius:2px;" >Get Data</button></td></tr> </table>     '

                //             //         var yAxisValue = this.y - 1;

                //             //         hs.htmlExpand(null, {
                //             //             pageOrigin: {
                //             //                 x: e.pageX + 60 || e.clientX + 60,
                //             //                 y: e.pageY + 60 || e.clientY + 60
                //             //             },
                //             //             headingText: '<span style=font-size:10px;>' + dateTime + ' ' + '-' + ' ' + '<b>(' + yAxisValue + ')</b></span>',
                //             //             maincontentText: htmlString,
                //             //             width: 200
                //             //         });
                //             //         hs.Expander.prototype.onBeforeClose = function (sender) {
                //             //         }
                //             //     }
                //             // }
                //         }
                //     }
                // }
            },
            title: {
                text: ''
            },
            xAxis: {
                showFirstLabel: true,
                // tickInterval: '172800000',
                //tickInterval: tickInterval,
                dateTimeLabelFormats: {
                    Hour: '%H'
                },
                type: 'datetime'
            },
            yAxis: {
                gridLineWidth: 1,
                lineWidth: 1,
                // title: {
                //     text: $scope.Unit
                // },
                labels: {
                    enabled: false
                },
                title: {
                    text: null
                }
            }, dataLabels: {
                enabled: true,
                crop: false,
                overflow: 'none'
            },
            plotOptions: {
                series: {
                    cursor: 'pointer',
                    point: {
                        events: {
                            click: function (e) {
                                self.chartPointClick(new Date(new Date(this.x).getTime() + (new Date(this.x).getTimezoneOffset() * 60000)), this.y-1, e);
                                // var toolTipDate = new Date(new Date(this.x).getTime() + (new Date(this.x).getTimezoneOffset() * 60000));
                                // var val=Highcharts.numberFormat(this.y, 2);
                                // self.chartClicked(toolTipDate,val);


                                //var toolTipDate = new Date(new Date(this.x).getTime() + (new Date(this.x).getTimezoneOffset() * 60000));
                                // var val = HighCharts.numberFormat(this.y, 2);
                                // var x = toolTipDate.toLocaleDateString();
                                // var t = new Date(x);
                                // var curr_date = t.getDate();
                                // var curr_month = t.getMonth() + 1; //Months are zero based
                                // var curr_year = t.getFullYear();
                                // var x1 = curr_year + "-" + curr_month + "-" + curr_date;
                                // var y = toolTipDate.toLocaleTimeString('en-US', { hour12: false });
                                // var dateVal = x1 + " " + y;
                                // self.chartClicked(dateVal, val, e.pageX - 240, e.pageY - 385);

                            }

                        }
                    }
                }
            },
            series: [{
                name: chartName,
                borderWidth: 0,
                connectNulls: false,
                data: chartData,
                dataLabels: true,
                groupPadding: 0.3,
                showInLegend: false,
                turboThreshold: 0,
                pointPadding: 0.6,
                shadow: false,
                tooltip: {
                    useHTML: true,
                    xDateFormat: '%m/%d/%Y %H:%M:%S',
                    valueDecimals: 2,
                    borderColor: 'steelblue',
                    pointFormat: '<span style="color: {point.color} !important"><b>{series.name}: </b><b style="color: black !important">{point.tooltip}<b/></span>',
                    // pointFormatter: function () {
                    //     var toolTipDate = new Date(new Date(this.x).getTime() + (new Date(this.x).getTimezoneOffset() * 60000));
                    //     var tooltiptext = '<span>' + HighCharts.dateFormat('%m/%d/' + self.seriesTooltipYear(toolTipDate, this.series.name.split('-')[0]) + ' %H:%M:%S ', this.x) + '</span>';
                    //     if (!isCodedValue)
                    //         tooltiptext = tooltiptext + '<br><span style="color:' + this.series.color + '">' + this.series.name + '</span><b>: ' + this.tooltip + ' </b></br>';
                    //     else
                    //         tooltiptext = tooltiptext + '<br><span style="color:' + this.series.color + '">' + this.tooltip + '</span><b> </b></br>';

                    //     return tooltiptext;
                    // }
                },
                marker: {
                    enabled: false
                }

            }]
        });
    }


    seriesTooltipYear(tooltipDate, seriesYear) {
        var tooltipDateYear = tooltipDate.getFullYear();
        if (isNaN(seriesYear))
            return tooltipDateYear;

        if ($("#dateSliderPointWiseAnalytics").html() != undefined) {
            var dateSliderMax = ($("#dateSliderPointWiseAnalytics") as any).dateRangeSlider("max");
            var toDateYear = dateSliderMax.getFullYear();
        }

        if (toDateYear > seriesYear)
            tooltipDateYear = tooltipDateYear - (toDateYear - seriesYear);

        return (tooltipDateYear - ((Math.abs(tooltipDateYear - seriesYear) - 1) < 0 ? 0 : (Math.abs(tooltipDateYear - seriesYear) - 1)));


    }

    chartClicked(dte, val, screenX, screenY) {
        // var len=$('div.chartPath-popup');
        // for(let i=0;i<len.length;i++)
        // {
        //     $('div.chartPath-popup')[i].remove();
        // }
        this.emitData = new EmitModel();
        this.emitData.name = this.pointName;
        this.emitData.screenX = screenX;
        this.emitData.screenY = screenY;
        this.chartClick.emit(this.emitData);
        //$('div.chartPath-popup').hide();
        //this.showGetData = false;
        this.dataTime = dte;
        this.dataValue = val;
        this.showGetData = true;
        //this.showDataPopUp = false;

    }

    showGridData(id, pointName, PointsDatatype, type) {
        if(this._oAuthService.hasValidAccessToken())
        {
            this.showGrid.emit([true, id, pointName, PointsDatatype, type]);
        }
        else{
            let alert = this.alertCtrl.create({
              subTitle: 'Session expired',
              buttons: [
                {
                  text:'OK',
                  handler:()=>{
                    this.securityConfig.logout();
                  }
                }],
              enableBackdropDismiss: false
          });
          alert.present();
          }
        
}

}
export class EmitModel {
    name: string = "";
    screenX: string = "";
    screenY: string = "";
}

export class chartSeries {
    name: string;
    color: string;
    data: any;
    connectNulls: boolean;
    //data: JSON.parse(dataRuntime),
    dataLabels: boolean;
    showInLegend: boolean;
    turboThreshold: number;
    pointPadding: number;
    groupPadding: number;
    borderWidth: number;
    shadow: boolean;
    tooltip: {
        headerFormat: string,
        pointFormat: string,
        xDateFormat: string
    };
    marker: {
        enabled: boolean
    }
}


// WEBPACK FOOTER //
// ./src/components/trends/trends-components/trends-charts-card.component.ts